<script setup>
defineProps({
  title: String,
  subtitle: String,
  icon: String,
});
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">{{ title }}</h5>
          <div v-if="subtitle" class="text-muted small">{{ subtitle }}</div>
        </div>
        <i v-if="icon" :class="`bi ${icon} text-primary fs-4`"></i>
      </div>
      <slot />
    </div>
  </div>
</template>
